import React, { useContext, useEffect } from "react";
import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import { dispError } from "../../utils/Tools";

function SplashScreen(props) {
  const appDispatch = useContext(DispatchContext);

  useEffect(() => {
    DataFetcher.fetch(DataFetcher.USER.VERIFY, {})
      .then(response => {
        if (!response.success) return appDispatch(dispError(response.msg));
        appDispatch({ type: "userdata", data: response.user });
      })
      .catch(error => console.error);
  }, [appDispatch]);

  return (
    <main className="splash">
      <progress></progress>
    </main>
  );
}
export default SplashScreen;
